import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyShopRegionDialogContent = loadable(() => import(/* webpackChunkName: "content/shopregiondialog" */ './ShopRegionDialogContent'), 'ShopRegionDialogContent');
